// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"InsuranceForm_sectionTitle__3guiT","insuranceGrid":"InsuranceForm_insuranceGrid__WUxjZ"};